import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { setLoading } from '../../store/slices/uiState';
import { useAppDispatch } from '../../store/store';
import { CONVOV2_LK_CONVERSATIONS_ROUTE } from './constants';

type ConversationVersion = 'legacy' | 'livekit';

type Props = {
  requestedVersion: ConversationVersion;
};

export const ConversationVersionMismatchDialog = ({ requestedVersion }: Props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const requestedLiveKit = requestedVersion === 'livekit';
  const title = requestedLiveKit
    ? 'This conversation uses the new captions experience'
    : 'This invite uses Classic Captions';
  const description = requestedLiveKit
    ? 'Your account is currently set to use Classic Captions, so this LiveKit invite cannot be opened here. Ask the host for a compatible invite.'
    : 'Your account is currently set to use the new LiveKit captions experience, so this classic invite cannot be opened here. Ask the host for a compatible invite.';
  const destination = requestedLiveKit ? '/web/conversations' : CONVOV2_LK_CONVERSATIONS_ROUTE;

  useEffect(() => {
    dispatch(setLoading({ isLoading: false }));
  }, [dispatch]);

  const handleGoToConversations = () => {
    // Clear any pending legacy invite artifacts so leaving this dialog does not
    // re-trigger a join into the mismatched conversation version.
    localStorage.removeItem('ava_request');
    localStorage.removeItem('via_branch');
    sessionStorage.removeItem('join_by_qrcode_token');
    navigate(destination, { replace: true });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth sx={{ zIndex: (theme) => theme.zIndex.modal + 200 }}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleGoToConversations}>
          Go to conversations
        </Button>
      </DialogActions>
    </Dialog>
  );
};
